const getAmountPaid = require('../paymentMethods/getAmountPaid');
const helpers = require('./helpers');

let moneyFloor = n => Math.floor(n*100);

module.exports = function({ items, reduced, added = [], added_reduced = [], added_charges = [], payments }){

  const paymentAmount = getAmountPaid({ payments });
  const amountTotal = helpers.calculateAmountTotalFromItems({ 
    items, 
    reduced, 
    added, 
    added_reduced,
    added_charges
  });

  return moneyFloor(paymentAmount) >= moneyFloor(amountTotal);
};